import React from "react";

/**
 * BillSummaryBar — Top compact 3-cell summary (Products / Total Qty / Total MRP)
 *
 * Matches the existing data-testids exactly to preserve test/UX behaviour.
 */
export default function BillSummaryBar({ productCount, totalQuantity, totalMRP }) {
  return (
    <div
      className="mt-4 grid grid-cols-3 rounded-lg border border-[hsl(var(--border))] bg-[#f8f9fb] shadow-sm overflow-hidden"
      data-testid="bill-summary-bar"
    >
      <div className="px-3 py-2 text-center border-r border-[hsl(var(--border))]">
        <div className="text-[10px] uppercase tracking-wider text-muted-foreground">Products</div>
        <div className="font-mono-data text-base font-semibold text-slate-800 mt-0.5" data-testid="bill-products-count">
          {productCount}
        </div>
      </div>
      <div className="px-3 py-2 text-center border-r border-[hsl(var(--border))]">
        <div className="text-[10px] uppercase tracking-wider text-muted-foreground">Total Qty</div>
        <div className="font-mono-data text-base font-semibold text-slate-800 mt-0.5" data-testid="bill-total-qty">
          {totalQuantity}
        </div>
      </div>
      <div className="px-3 py-2 text-center">
        <div className="text-[10px] uppercase tracking-wider text-muted-foreground">Total MRP</div>
        <div className="font-mono-data text-base font-semibold text-slate-800 mt-0.5" data-testid="bill-total-mrp">
          ₹{Number(totalMRP || 0).toFixed(2)}
        </div>
      </div>
    </div>
  );
}
